import ClientLeadCreate from './ClientLeadCreate';
import ClientLeadEditContact from './ClientLeadEditContact';
import ClientLeadEditName from './ClientLeadEditName';
import ClientLeadEditStatus from './ClientLeadEditStatus';
import ClientLeadRemoveContact from './ClientLeadRemoveContact';

const UPDATE_TYPES = {
  'CLIENT_LEAD_CREATE': {
    title: 'clientLead.ClientLeadDetail.Correspondance.Correspondance.Logs.CreatedOn',
    component: ClientLeadCreate,
  },
  'CLIENT_LEAD_EDIT_NAME': {
    title: 'clientLead.ClientLeadDetail.Correspondance.Correspondance.Logs.EditName',
    component: ClientLeadEditName,
  },
  'CLIENT_LEAD_EDIT_STATUS': {
    title: 'clientLead.ClientLeadDetail.Correspondance.Correspondance.Logs.EditStatus',
    component: ClientLeadEditStatus,
  },
  'CLIENT_LEAD_EDIT_CONTACT': {
    title: 'clientLead.ClientLeadDetail.Correspondance.Correspondance.Logs.EditContact',
    component: ClientLeadEditContact,
  },
  'CLIENT_LEAD_REMOVE_CONTACT': {
    title: 'clientLead.ClientLeadDetail.Correspondance.Correspondance.Logs.RemoveContact',
    component: ClientLeadRemoveContact,
  },
};

export {
  UPDATE_TYPES,
};
